export default __webpack_public_path__ + "static/media/hospitales.7d2664c1.png";